/** Type guard: narrows an untyped parsed body to the success shape. */
export function isSuccessEnvelope(body) {
    return 'data' in body;
}
/** Type guard: narrows an untyped parsed body to the error shape. */
export function isErrorEnvelope(body) {
    return 'error' in body;
}
//# sourceMappingURL=envelope.js.map